import { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { useDispatch } from "react-redux";
import Loader from "../Common/Loader";

import {
  createMedicineTypeAction,
  updateMedicineTypeAction,
} from "../../../store/actions/MedicineTypeActions";

const AddMedicineType = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { item } = location.state || {};
  const isEditMode = !!item;

  const [text, setText] = useState("");
  const [status, setStatus] = useState(1);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const statusOptions = [
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
  ];

  /* ======================
     PREFILL EDIT DATA
  ====================== */
  useEffect(() => {
    if (item) {
      setText(item.medicine_type_text || "");
      setStatus(item.medicine_type_status === "Active" ? 1 : 0);
    }
  }, [item]);

  /* ======================
     VALIDATION
  ====================== */
  const validateForm = () => {
    const err = {};
    if (!text.trim()) err.text = "Medicine type is required";
    if (status === "" || status === null)
      err.status = "Status is required";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const clearFieldError = (field) => {
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const { [field]: _removed, ...rest } = prev;
      return rest;
    });
  };

  const handleFieldChange = (field, value) => {
    if (field === "text") {
      setText(value);
    } else if (field === "status") {
      setStatus(value);
    }
    clearFieldError(field);
  };

  /* ======================
     SUBMIT
  ====================== */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      medicine_type_text: text,
      medicine_type_status: status === 1 ? "Active" : "Inactive",
    };

    try {
      setLoading(true);

      if (isEditMode) {
        await dispatch(
          updateMedicineTypeAction(
            payload,
            item.medicine_type_id
          )
        );
      } else {
        await dispatch(createMedicineTypeAction(payload));
      }

      navigate("/medicine-types");
    } catch (err) {
      console.error("Save failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-xl-12">

        <div className="d-flex justify-content-end mb-3">
          <Link to="/medicine-types">
            <Button variant="primary">Back</Button>
          </Link>
        </div>

        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>

              {/* TEXT */}
              <div className="mb-3">
                <label className="form-label">
                  Medicine Type <span className="text-danger">*</span>
                </label>

                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter medicine type"
                  value={text}
                  style={{ padding: "0.375rem 0.75rem", paddingTop: "0.6rem" }}
                  onChange={(e) => handleFieldChange("text", e.target.value)}
                />

                {errors.text && (
                  <div className="text-danger mt-1">
                    {errors.text}
                  </div>
                )}
              </div>

              {/* STATUS */}
              <div className="mb-3">
                <label className="form-label">
                  Status <span className="text-danger">*</span>
                </label>

                <Select
                  options={statusOptions}
                  value={statusOptions.find((opt) => opt.value === status)}
                  onChange={(selectedOption) =>
                    setStatus(selectedOption ? selectedOption.value : "")
                  }
                  placeholder="Select Status"
                  isClearable
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      minHeight: "50px",
                      height: "50px",
                      borderColor: errors.status
                        ? "#dc3545"
                        : provided.borderColor,
                      boxShadow: errors.status
                        ? "0 0 0 0.2rem rgba(220,53,69,.25)"
                        : provided.boxShadow,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      lineHeight: "50px",
                    }),
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      padding: "4px",
                    }),
                    indicatorSeparator: () => ({
                      display: "none",
                    }),
                  }}
                />

                {errors.status && (
                  <small className="text-danger">{errors.status}</small>
                )}
              </div>


              {/* BUTTON */}
              <button className="btn btn-primary" disabled={loading}>
                {loading ? (
                  <>
                    <Loader size="sm" /> Saving...
                  </>
                ) : isEditMode ? (
                  "Update Medicine Type"
                ) : (
                  "Add Medicine Type"
                )}
              </button>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMedicineType;
